<template>
  <div>
    <div v-if="!isFooterOnly">
      <div class="tabs">
        <ul>
          <li
            v-for="(tab, i) in tabs"
            :key="tab.name"
            :class="{ 'is-active': currentTabIndex === i }"
          >
            <a @click="updateModalTab(i)">{{ tab.name }}</a>
          </li>
        </ul>
      </div>
      <div v-if="error" class="notification is-danger is-light" role="alert">
        {{ error }}
      </div>
      <camera-components
        v-if="tabs[currentTabIndex].name === 'Components'"
        :inventory-id="device.id"
      />
      <!-- keep-alive: the one-time setup code must survive a tab switch -->
      <keep-alive v-else>
        <component
          :is="tabs[currentTabIndex].component"
          :device-data="device"
          @changed="handleChanged"
        />
      </keep-alive>
    </div>

    <div v-else class="buttons">
      <button class="button" @click="closeTopModal">Close</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { getInventory } from "@/api/components";
import CameraComponents from "@/components/CameraComponents.vue";
import General from "./tabs/General.vue";
import Report from "./tabs/Report.vue";
import Sites from "./tabs/Sites.vue";

const POLL_INTERVAL_MS = 30000;

export default {
  name: "ModalProCameraInventory",
  components: { CameraComponents },
  props: {
    modalData: { type: Object, default: null },
    modalIndex: { type: Number, required: true },
    isFooterOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      device: this.modalData || {},
      error: "",
      pollTimer: null,
      tabs: [
        { name: "General", component: General },
        { name: "Last Report", component: Report },
        { name: "History", component: Sites },
        { name: "Components", component: null },
      ],
    };
  },
  computed: {
    currentTabIndex() {
      return this.$store.state.modalStack[this.modalIndex]?.activeTabIndex || 0;
    },
  },
  methods: {
    ...mapActions(["closeTopModal", "fetchList", "updateModalTab"]),
    async load() {
      if (!this.device.id) return;
      try {
        this.device = await getInventory(this.device.id);
        this.error = "";
      } catch (error) {
        this.error = error.message;
      }
    },
    handleChanged() {
      this.load();
      this.fetchList({ silent: true });
    },
  },
  mounted() {
    if (this.isFooterOnly) return;
    this.load();
    this.pollTimer = setInterval(() => {
      if (!document.hidden) this.load();
    }, POLL_INTERVAL_MS);
  },
  beforeDestroy() {
    clearInterval(this.pollTimer);
  },
};
</script>

<style scoped>
.buttons { justify-content: flex-end; }
</style>
